import React, { useState, useEffect, useRef,useMemo } from "react";
import { getTenantNotebook, getPageDataset } from "./api";
import PageDatasetTable from "./PageDatasetTable";
import { FolderPageContent } from "./FolderPageContent";
import { useParams, useNavigate } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import './index.css'; // we’ll create a CSS file for styles
import { Shimmer } from "./Shimmer";
import {FolderTree} from "./components/FolderTree";
import './components/FolderButtons.css'; // Custom CSS for styling
import './components/NoteBook.css'; // Custom CSS for styling
import {YamlEditor} from "./components/YamlEditor";
import {SettingsPanel} from "./components/SettingsPanel";
import {DeletePanel} from "./components/DeletePanel";


function NotebookTabs({ tenants, onLogout }) {
  // ========== URL + STATE ==========
  const navigate = useNavigate();

  const params = useParams();

  
  const [section, setSection] = useState(() => params.section || "user");
  const [groupFromUrl] = useState(() => params.notebook || null);
  const [pageFromUrl] = useState(() => params.page || null);
  const [folderFromUrl] = useState(() => params.folder || "Root");

  const tenant = window.location.pathname.split("/")[0];
  const sections = ["user", "build", "coordination"]; 
  const [projects, setProjects] = useState([]);
  const [project, setProject] = useState(() => params.project || projects[0]);

  // Notebook + dataset
  const [notebook, setNotebook] = useState(null);
  const [pageDataset, setPageDataset] = useState([]);
  const [notebookCache, setNotebookCache] = useState({});
  const [datasetCache, setDatasetCache] = useState({});
  const [loadingNotebook, setLoadingNotebook] = useState(false);


  // Active indices
  const [activeGroupIndex, setActiveGroupIndex] = useState(0);
  const [activePageIndex, setActivePageIndex] = useState(0);
  const [activeFolderIndex, setActiveFolderIndex] = useState(0);
  const [activeFolderPath, setActiveFolderPath] = useState([]); 
  const [flatFolders, setFlatFolders] = useState([]); // flat full-path list from backend
  const [currentFolder, setCurrentFolder] = useState(folderFromUrl || "Root");


  const [loading, setLoading] = useState(true);
  const [loadingDataset, setLoadingDataset] = useState(false);
  const [error, setError] = useState(null);


  const leftPanelRef = useRef(null);
  const rightPanelRef = useRef(null);
  const SubleftPanelRef = useRef(null);
  const SubRightPanelRef = useRef(null);
  const [isLeftHidden, setIsLeftHidden] = useState(true);
  const [isSubRightHidden, setIsSubRightHidden] = useState(true);
  const [rightPanelMode, setRightPanelMode] = useState("folders");
  

  const isRightPanelOpen = rightPanelMode !== null;
  useEffect(() => {
    if (rightPanelMode === null) {
      setIsSubRightHidden(true);
    }
  }, [rightPanelMode]);
  const toggleRightPanelMode = (mode) => {
    if (rightPanelMode === mode) {
      setRightPanelMode(null); // clicking same mode closes
      setIsSubRightHidden(true);
    } else {
      setRightPanelMode(mode); // clicking new mode switches
      setIsSubRightHidden(false);
    }
  };

  const handleVisibilityUpdate = (newVisibility) => {
  console.log("Visibility changed:", newVisibility);
  // You can save this to API later
};

const handleDelete = () => {
  console.log("Delete confirmed:", currentFolder);
  // Call API here then close panel
  setRightPanelMode("folders");
};
  const toggleLeftPanel = () => {
    setIsLeftHidden(!isLeftHidden);
  };
  {/* === Mini button style === */}
  const miniBtnStyle = {
    border: "none",
    background: "#fff",
    cursor: "pointer",
    fontSize: "18px",
    padding: "6px",
    borderRadius: "4px",
    transition: "all 0.2s",
    boxShadow: "0 1px 2px rgba(0,0,0,0.2)",
  };
    const BtnStyle = {
    border: "none",
    background: "#fff",
    cursor: "pointer",
    fontSize: "18px",
    padding: "0px",
    borderRadius: "4px",
    transition: "all 0.2s",
    boxShadow: "0 1px 1px rgba(0,0,0,0.2)",
  };


// ---------- 1) Fetch notebook whenever project or section changes ----------
// ---------- Unified effect ----------
useEffect(() => {
  if (!project || !section) return;

  const fetchNotebookAndPage = async () => {
    setLoadingNotebook(true);
    setLoadingDataset(true);
    setPageDataset({}); // clear old page while loading

    try {
      // 1️⃣ Fetch notebook
      const data = await getTenantNotebook(tenant, project, section);
      setNotebook(data);

      // 2️⃣ Update projects list
      if (data.projects) {
        setProjects(data.projects);
        if (!project && data.projects.length > 0) {
          setProject(data.projects[0].id || data.projects[0]);
        }
      }

      // 3️⃣ Resolve active indices
      const g = data.notebooks.findIndex(n => n.group === groupFromUrl);
      const p = data.notebooks[g]?.pages.findIndex(pg => pg.title === pageFromUrl);
      const f = data.folders.findIndex(f => f.caption === folderFromUrl);

      const activeG = g >= 0 ? g : 0;
      const activeP = p >= 0 ? p : 0;
      const activeF = f >= 0 ? f : 0;

      setActiveGroupIndex(activeG);
      setActivePageIndex(activeP);
      setActiveFolderIndex(activeF);

      // 4️⃣ Sync clean URL
      navigate(
        `/${project}/${section}/${data.notebooks[activeG]?.group}/${data.notebooks[activeG]?.pages[activeP]?.title}/${data.folders[activeF]?.caption}/get-notebook`,
        { replace: true }
      );

      // 5️⃣ Prepare page cache key
      const groupObj = data.notebooks[activeG];
      const pageObj = groupObj.pages[activeP];
      const folderCaption = data.folders[activeF]?.caption || '';
      const cacheKey = `${project}_${section}_${groupObj.group}_${pageObj.title}_${folderCaption}`;

      // 6️⃣ Load page dataset only if not cached
      if (datasetCache[cacheKey]) {
        setPageDataset(datasetCache[cacheKey]);
      } else {
        const pageData = await getPageDataset(
          tenant,
          project,
          section,
          groupObj.group,
          pageObj.title,
          folderCaption
        );
        setDatasetCache(prev => ({ ...prev, [cacheKey]: pageData }));
        setPageDataset(pageData);
      }
    } catch (err) {
      console.error("Error loading notebook or page dataset", err);
      setPageDataset([]);
    } finally {
      setLoadingNotebook(false);
      setLoadingDataset(false);
    }
  };

  fetchNotebookAndPage();
}, [tenant, project, section]);


// Update projects whenever notebook changes
useEffect(() => {
  if (notebook?.projects) {
    setProjects(notebook.projects);

    // Optional: set default selected project if none selected
    if (!project && notebook.projects.length > 0) {
      setProject(notebook.projects[0].id || notebook.projects[0]);
    }
  }
}, [notebook]);


// ---------- 2) Fetch page dataset whenever notebook OR group OR page OR folder changes ----------
const lastClickedFolderRef = useRef(null);

// 2️⃣ Page dataset fetch
// Fetch dataset whenever notebook OR active group/page/folder changes
const skipFetchRef = useRef(false);
useEffect(() => {
  if (!notebook) return;

  const group = notebook.notebooks[activeGroupIndex];
  const page  = group.pages[activePageIndex];

  if (!group || !page) return;

  const cacheKey = `${project}_${section}_${group.group}_${page.title}_${currentFolder}`;

  // If data exists in cache -> load it
  const cached = datasetCache[cacheKey];
  if (cached) {
    setPageDataset(cached);
    return;
  }

  // Otherwise fetch
  setLoadingDataset(true);

  getPageDataset(tenant, project, section, group.group, page.title, currentFolder)
    .then(data => {
      setDatasetCache(prev => ({ ...prev, [cacheKey]: data }));
      setPageDataset(data);
    })
    .catch(() => setPageDataset([]))
    .finally(() => setLoadingDataset(false));
}, [notebook, activeGroupIndex, activePageIndex, currentFolder]);

useEffect(() => {
  setActivePageIndex(0); 
}, [activeGroupIndex]);

// Handle project/tenant change
const handleProjectChange = (e) => {
  const newProject = e.target.value;
  setProject(newProject);

  setActiveGroupIndex(0);
  setActivePageIndex(0);
  setActiveFolderIndex(0);

  navigate(`/${newProject}/${section}/_/_/_/get-notebook`, { replace: true });
};


// Handle section change
const handleSectionChange = (e) => {
  const newSection = e.target.value;
  setSection(newSection);

  setActiveGroupIndex(0);
  setActivePageIndex(0);
  setActiveFolderIndex(0);

  navigate(`/${project}/${newSection}/_/_/_/get-notebook`, { replace: true });
};
const handleGroupClick = (idx) => {
  setActiveGroupIndex(idx);
  setActivePageIndex(0); // reset to first page

  const group = notebook.notebooks[idx];
  const page = group.pages[0];
  const folder = notebook.folders[activeFolderIndex];

  navigate(
    `/${project}/${section}/${group.group}/${page.title}/${folder.caption}/get-notebook`,
    { replace: true }
  );
};
const handlePageClick = (idx) => {
  setActivePageIndex(idx);

  const group = notebook.notebooks[activeGroupIndex];
  const page = group.pages[idx];
  const folder = notebook.folders[activeFolderIndex];
  const folderCaption = folder.caption
  navigate(
    `/${project}/${section}/${group.group}/${page.title}/${folderCaption}/get-notebook`,
    { replace: true }
  );
};
const handleYamlSave = (json) => {
  console.log("YAML converted to JSON:", json);

  // Update local dataset
  setPageDataset(json);

  // TODO: send json back to API when ready
  // updatePageDataset(activePage.id, currentFolder, json);
};


const handleFolderClick = async (folderCaption) => {
  setCurrentFolder(folderCaption);

  const activeGroup = notebook.notebooks[activeGroupIndex];
  const activePage = activeGroup.pages[activePageIndex];

  try {
    const data = await getPageDataset(tenant,project,section,activeGroup.group,activePage.id, folderCaption);
    setPageDataset(data);
  } catch (err) {
    setPageDataset([]);
  }

  navigate(
    `/${project}/${section}/${activeGroup.group}/${activePage.title}/${folderCaption}/get-notebook`,
    { replace: true }
  );
};

useEffect(() => {
  if (!pageDataset) return;

  setNotebook(prev =>
    prev
      ? {
          ...prev,
          agents: pageDataset.agents ?? [],
          folders: pageDataset.folder_list ?? [],
        }
      : prev
  );
}, [pageDataset]);

const workspaceTitle = useMemo(() => {
  if (!pageDataset || typeof pageDataset !== "object") return project;

  if (!notebook) return project;

  const group = notebook.notebooks?.[activeGroupIndex];
  if (!group) return project;

  return `${project} ${group.group}`;
}, [pageDataset, project, notebook, activeGroupIndex]);


  if (!notebook?.notebooks?.length) return <div>Loading notebook...</div>;

  const activeGroup = notebook.notebooks[activeGroupIndex];
  const activePage = activeGroup.pages[activePageIndex];


  return (
    <div style={{ display: "grid", gridTemplateRows: "auto 1fr auto", height: "100vh", fontFamily: "Segoe UI, sans-serif" }}>
      {/* Top panel */}
      <div style={{ padding: "0.75rem 1.5rem", background: "#f3f3f3", borderBottom: "1px solid #ccc", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <button id="btnhide" onClick={toggleLeftPanel}>✏️</button>
          <h2 style={{ margin: 0 }}>{workspaceTitle}</h2>
        </div>
        <div style={{ display: "flex", gap: "0.5rem" }}>
          <select value={project} onChange={handleProjectChange}>
            {projects.map((t) => <option key={t} value={t}>{t}</option>)}
          </select>
          <select value={section} onChange={handleSectionChange}>
            {sections.map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
          <button>Create</button>
          <button>User</button>
        </div>
      </div>

    {/* Center panel */}
    <div
      style={{
        display: "grid",
        gridTemplateColumns: isLeftHidden ? "0fr 1fr" : "1.5fr 4.5fr",
        gap: "1rem",
        padding: "0.1rem",
        overflow: "hidden",
        height: "100%", // important for full height
        boxSizing: "border-box", // makes padding included in height
      }}
    >
  {/* Left panel */}
      <div
        ref={leftPanelRef}
        style={{
          borderRight: "1px solid #ccc",
          display: "flex",
          flexDirection: "column",
          height: "100%",
          overflow: "hidden",
          transition: "all 0.3s ease",
        }}
      >
        {/* Top bar */}
        {/* Middle scrollable content */}
        <div style={{ flex: 1, overflowY: "auto", padding: "0.5rem 1rem" }}>
          <h3>Groups</h3>
          {notebook.notebooks.map((group, idx) => (
            <button
              key={idx}
              className={`tab-button ${idx === activeGroupIndex ? "active" : ""}`}
              onClick={() => {
                setActiveGroupIndex(idx);
                setActivePageIndex(0); // folder page
                setActiveFolderIndex(activeFolderIndex);
                navigate(
                  `/${project}/${section}/${group.group}/${group.pages[0].title}/${notebook.folders[activeFolderIndex].caption}/get-notebook`,
                  { replace: true }
                );
              }}
            >
              {group.group}
            </button>
          ))}
        </div>

        {/* === Bottom bar (4 buttons) === */}
        <div className="btn-container" style={{ flexShrink: 0 }}>
          <div className="folder-buttons">
            <button title="Add" className="flat-btn" >➕</button>
            <button title="Edit" className="flat-btn">✏️</button>
            <button title="Remove" className="flat-btn">🗑️</button>
            <button title="Remove" className="flat-btn">⚙️</button>
          </div>
        </div>
      </div>
        {/* Right panel */}
        <div
          ref={rightPanelRef}
          style={{
            height: "100%",            // fill parent height
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            paddingLeft: "0.1rem",
          }}
        >
        <div className="page-tabs">
          {activeGroup.pages.map((page, idx) => (
            <button
              key={idx}
              className={`page-tab ${idx === activePageIndex ? "active-page-tab" : ""}`}
              onClick={() => handlePageClick(idx)}
            >
              {page.title}
            </button>
          ))}
        </div>

        {/* Main content area */}
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "0.25rem",         // tightened gap
              flexWrap: "wrap",
              flexShrink: 0,
              marginTop: "-0.25rem",  // pull up closer to tabs
            }}
          >
              {/* Left: Folder buttons */}
            <div style={{ display: "flex", gap: "0.25rem", flexWrap: "wrap" }}>
              {notebook.agents.map((agent, idx) => (
                <label
                  key={idx}
                  style={{
                    padding: "0.25rem 0.5rem",   // tighter label buttons
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    cursor: "pointer",
                    userSelect: "none",
                  }}
                >
                  {agent.caption}
                </label>
              ))}
            </div>

              {/* Right: Action buttons */}
            <div className="btn-container">
              <div className="folder-buttons">
                <button className="flat-btn top-btn" onClick={() => toggleRightPanelMode("folders")}>➕</button>
                <button className="flat-btn top-btn" onClick={() => toggleRightPanelMode("yaml")}>✏️</button>
                <button className="flat-btn top-btn" onClick={() => toggleRightPanelMode("settings")}>⚙️</button>
                <button className="flat-btn top-btn" onClick={() => toggleRightPanelMode("delete")}>🗑️</button>
              </div>
            </div>

            </div>
            {/* Grid panels */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: isSubRightHidden ? "1fr 0fr" : "4.5fr 1.5fr",
                gap: "1rem",
                padding: "0.1rem",
                flex: 1,
                height: "100%",       // make grid fill parent flex container
                overflow: "hidden",
              }}
            > 
              {/* left panel */}
            <div
              ref={SubleftPanelRef}
              style={{
                display: "flex",
                flexDirection: "column",
                height: "100%",      // fill grid row
                overflow: "hidden",
                position: "relative", // needed for absolute loading overlay
              }}
            >            
              <PageDatasetTable
                pageDataset={pageDataset}
                setPageDataset={setPageDataset}
                pageId={activePage.id}
                parentData={{ project, section, activeGroup, activePage, currentFolder }}
              />
              {loadingDataset && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: "rgba(255,255,255,0.7)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 10,
                  }}
                >
                  <span>Loading dataset...</span>
                </div>
              )}
            </div>
              {/* Right panel */}
              <div
                ref={SubRightPanelRef}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                  
                  overflow: "hidden",
                  borderRight: "1px solid #ccc",
                  transition: "all 0.3s ease",
                }}
              >
              {/* Middle scrollable content */}
              <div style={{ flex: 1, overflowY: "auto", padding: "0.1rem 0.5rem" }}>
                {rightPanelMode === "folders" && <FolderTree folders={flatFolders} currentFolder={currentFolder} onFolderClick={handleFolderClick} />}
                {rightPanelMode === "yaml" && <YamlEditor pageDataset={pageDataset} onSave={handleYamlSave} />}
                {rightPanelMode === "settings" && <SettingsPanel currentFolder={currentFolder} onChangeVisibility={handleVisibilityUpdate} />}
                {rightPanelMode === "delete" && <DeletePanel folder={currentFolder} onConfirm={handleDelete} onCancel={() => setRightPanelMode("folders")} />}
              </div>

            </div>
          </div>
        </div>
      </div>
      </div>

      {/* Bottom panel */}
      <div className="page-content" style={{flexShrink:0,boxSizing: "border-box"}}>
        {loading ? (
          <Shimmer lines={0} />
        ) : (
          <div
            style={{
              background: "#fafafa",
              borderTop: "1px solid #ccc",
              padding: "0.5rem 1rem",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              fontSize: "0.9rem",
            }}
          >
            <span>Status: Ready</span>
            <span>v1.0.0 | Flask ↔ React | © 2025</span>
          </div>
        )}
      </div>


      <style>{`
        .tab-button { padding: 0.5rem; cursor: pointer; border-radius: 4px; border: none; background: #f3f3f3; width: 100%; text-align: left; margin-bottom: 0.3rem; transition: 0.2s; }
        .tab-button:hover { background: #e0e0e0; }
        .tab-button.active { background: #0078d7; color: white; font-weight: bold; }

        .page-tabs { display: flex; gap: 0.5rem; flex-wrap: wrap; padding-bottom: 0.5rem; margin-top:0.25rem}
        .page-tab { padding: 0.5rem 1rem; cursor: pointer; border-radius: 4px; border: none; background: #f3f3f3; transition: 0.2s; }
        .page-tab:hover { background: #e0e0e0; }
        .page-tab.active-page-tab { background: #0078d7; color: white; font-weight: bold; }

        button { cursor: pointer; border-radius: 4px; border: 1px solid #ccc; padding: 0.4rem 0.8rem; background: white; transition: 0.2s; }
        button:hover { background: #f0f0f0; }
        select { padding: 0.4rem 0.8rem; border-radius: 4px; border: 1px solid #ccc; background: white; cursor: pointer; }
      `}</style>
    </div>
  );
}


function TenantProtectedNotebook({ tenants, jwtToken, onLogout }) {
  const navigate = useNavigate();

  useEffect(() => {
    // 1. If the "Class" token is missing, boot to login
    if (!jwtToken) {
      navigate('/login'); 
    } 
    // 2. If we have a token but no tenants list yet, go back to fetch them
    else if (!tenants || tenants.length === 0) {
      navigate('/tenants');
    }
  }, [jwtToken, tenants, navigate]);

  // Safety render
  if (!jwtToken || !tenants || tenants.length === 0) {
    return null; 
  }

  return (
    <ProtectedRoute token={jwtToken}>
      {/* 🚀 You can now pass 'tenants' directly from your User Class here */}
      <NotebookTabs tenants={tenants} onLogout={onLogout} />
    </ProtectedRoute>
  );
}

export { NotebookTabs, TenantProtectedNotebook };